import { CognitoUser } from '@aws-amplify/auth'
import { Auth } from 'aws-amplify'

const MFA_TYPE = 'SMS_MFA'

interface Credentials {
    username: string
    password: string
}

interface Attributes {
    email: string
    phone_number: string
}

interface SignUpData extends Credentials {
    attributes: Attributes
}

type SignInData = Credentials

interface ConfirmSignInData {
    user: CognitoUser
    code: string
}

interface ResetPasswordData {
    email: string
}

interface ConfirmPasswordData {
    email: string
    code: string
    password: string
}

class AuthService {
    signUp(data: SignUpData) {
        return Auth.signUp(data)
    }

    signIn(data: SignInData) {
        return Auth.signIn(data)
    }

    confirmSignIn(data: ConfirmSignInData) {
        return Auth.confirmSignIn(data.user, data.code, MFA_TYPE)
    }

    signOut() {
        return Auth.signOut()
    }

    resendCode(codeType: 'phone_number' | 'email' = 'phone_number') {
        return Auth.verifyCurrentUserAttribute(codeType)
    }

    confirmAttributeByCode(
        codeType: 'phone_number' | 'email' = 'phone_number',
        code: string,
    ) {
        return Auth.verifyCurrentUserAttributeSubmit(codeType, code)
    }

    getUser() {
        return Auth.currentAuthenticatedUser()
    }

    resetPassword(data: ResetPasswordData) {
        return Auth.forgotPassword(data.email)
    }

    confirmPassword(data: ConfirmPasswordData) {
        return Auth.forgotPasswordSubmit(data.email, data.code, data.password)
    }
}

export const authService = new AuthService()
